import React, { useState, useEffect, useContext } from 'react';
import { useForm, FormContext } from 'react-hook-form';
import { useHistory, useLocation } from 'react-router-dom';
import { EirCustomerDetails } from './EirCustomerDetails';
import { EirAddressDetails } from './EirAddressDetails';
import { Paper } from '@material-ui/core';
import { EirRegisteredCustomer } from './EirRegisteredCustomer';
import { useStyle } from './style';
import { EirCheckoutHeader } from './EirCheckoutHeader';
import { EirOrderSummary } from './EirOrderSummary';
import { EirTermsNConditions } from './EirTermsNConditions';
import errormesages from './errormessages';
import { useApolloClient } from '@apollo/client';
import ENDPOINT from '../graphql/GraphQLConstants';
import { PROSPECT_DATE_FORMAT, DATE_FORMAT } from './constants';
import moment from 'moment';
import { CheckoutContext } from '../eir-checkout/EirCheckoutContainer';
import { PREPAY_PLAN_URL } from '../eir-prepay-constants/ApplicationConstants';
import EirEmptyCart from '../eir-review-order/EirEmptyCart';

export const EirCustomerDetailsContainer = (props) => {
	const { setCurrentUrl, nextStepUrl, customerInformation, setCustomerInformation } = props;
	const { errormessage, validation } = errormesages;
	const location = useLocation();
	const currentUrl = location.pathname;
	const classes = useStyle();
	const history = useHistory();
	const graphql = useApolloClient();
	const { cartDetails, setCartDetails, totalPrice } = useContext(CheckoutContext);
	const [directoryPreference, setDirectoryPreference] = useState('EXDIRECTORY');
	const [customerType, setCustomerType] = useState('registered');
	const [continueDisabled, setContinueDisabled] = useState(false);
	const [customerUpdateError, setCustomerUpdateError] = useState('');

	useEffect(() => {
		setCurrentUrl(currentUrl);
		if (customerInformation != null && customerInformation.owner != null) {
			setCustomerType(customerInformation.isAnonymous ? 'guest' : 'registered');
		}

		if (cartDetails != null && cartDetails.offerId != null) {
			setDirectoryPreference(cartDetails.nddPreference);
		}
		window.scrollTo(0, 0);
		window.history.scrollRestoration = 'manual';
	}, []);


	const setDefaultValues = () => {
		if (customerInformation != null && customerInformation.owner != null) {

			if (!customerInformation.isAnonymous) {
				// convert date into dd-mm-yyyy
				const birthDate = moment(customerInformation.owner.person.birthDate, PROSPECT_DATE_FORMAT).format(DATE_FORMAT);

				return {
					firstName: customerInformation.owner.person.firstName,
					lastName: customerInformation.owner.person.lastName,
					emailAddress: customerInformation.owner.email,
					mobileNumber: customerInformation.owner.mobileNumber,
					birthDate: birthDate,
					billingAddressaddressLine1: customerInformation.billingAddress.addressLine1,
					billingAddressaddressLine2: customerInformation.billingAddress.addressLine2,
					billingAddressaddressLine3: customerInformation.billingAddress.addressLine3,
					billingAddresstown: customerInformation.billingAddress.town,
					billingAddresscounty: customerInformation.billingAddress.county,
					billingAddressEirCode: customerInformation.billingAddress.eircode,
					deliveryAddressaddressLine1: customerInformation.deliveryAddress.addressLine1,
					deliveryAddressaddressLine2: customerInformation.deliveryAddress.addressLine2,
					deliveryAddressaddressLine3: customerInformation.deliveryAddress.addressLine3,
					deliveryAddresstown: customerInformation.deliveryAddress.town,
					deliveryAddresscounty: customerInformation.deliveryAddress.county,
					deliveryAddressEirCode: customerInformation.deliveryAddress.eircode,
					securityQuestion: customerInformation.securityQuestion.questionCode,
					securityAnswer: customerInformation.securityQuestion.response,

				}
			}
			else {
				return {
					firstName: customerInformation.owner.person.firstName,
					lastName: customerInformation.owner.person.lastName,
					emailAddress: customerInformation.owner.email,
					mobileNumber: customerInformation.owner.mobileNumber,
					deliveryAddressaddressLine1: customerInformation.deliveryAddress.addressLine1,
					deliveryAddressaddressLine2: customerInformation.deliveryAddress.addressLine2,
					deliveryAddressaddressLine3: customerInformation.deliveryAddress.addressLine3,
					deliveryAddresstown: customerInformation.deliveryAddress.town,
					deliveryAddresscounty: customerInformation.deliveryAddress.county,
					deliveryAddressEirCode: customerInformation.deliveryAddress.eircode,
				}

			}
		}

	}

	const methods = useForm(
		{
			mode: 'onChange',
			defaultValues: setDefaultValues(),

		}
	);

	const isEirCodeConfirmed = () => {
		let yourAddress = customerType === 'registered' ? methods.getValues('billingAddressyourAddress') : methods.getValues('deliveryAddressyourAddress');
		let eirCodeConfirmed = true;
		if (customerType === 'registered') {
			if (yourAddress === undefined) {
				methods.setError('billingAddressEirCode', 'manual', errormessage.eircodeNotConfirmed);
				eirCodeConfirmed = false;
				var billingEirCode = document.querySelector('#billingAddressEirCode');
				billingEirCode.scrollIntoView();
			}
			if (!methods.getValues('sameDeliveryAddress')) {
				let deliveryAddressline = methods.getValues('deliveryAddressyourAddress');
				if (deliveryAddressline === undefined) {
					methods.setError('deliveryAddressEirCode', 'manual', errormessage.eircodeNotConfirmed);
					eirCodeConfirmed = false;
					var deliveryEirCode = document.querySelector('#deliveryAddressEirCode');
					deliveryEirCode.scrollIntoView();
				}
			}
		}
		else if (yourAddress === undefined) {
			methods.setError('deliveryAddressEirCode', 'manual', errormessage.eircodeNotConfirmed);
			eirCodeConfirmed = false;
			deliveryEirCode = document.querySelector('#deliveryAddressEirCode');
			deliveryEirCode.scrollIntoView();

		}

		return eirCodeConfirmed;
	}
	const updateCustomerDetails = async (data) => {

		const prospectUuid = localStorage.getItem('prospectUuid');
		const cartOfferId = localStorage.getItem('offerId');
		setContinueDisabled(true);
		let customerDetailInput;
		let nddPreference = 'EXDIRECTORY';
		try {
			if (customerType === 'registered') {
				nddPreference = directoryPreference;
				const permissionGroupList = JSON.parse(data.permissionGroupList);
				// convert date into yyyy-mm-dd
				const birthDate = moment(data.birthDate, DATE_FORMAT).format(PROSPECT_DATE_FORMAT);
				let deliveryaddressLine1;
				let deliveryaddressLine2;
				let deliveryaddressLine3;
				let deliveryTown;
				let deliveryCounty;
				let deliveryEirCode;

				// if delivery address same as billing address
				if (data.sameDeliveryAddress) {
					deliveryaddressLine1 = data.billingAddressaddressLine1;
					deliveryaddressLine2 = data.billingAddressaddressLine2;
					deliveryaddressLine3 = data.billingAddressaddressLine3;
					deliveryTown = data.billingAddresstown;
					deliveryCounty = data.billingAddresscounty;
					deliveryEirCode = data.billingAddressEirCode;
				}
				else {
					deliveryaddressLine1 = data.deliveryAddressaddressLine1;
					deliveryaddressLine2 = data.deliveryAddressaddressLine2;
					deliveryaddressLine3 = data.deliveryAddressaddressLine3;
					deliveryTown = data.deliveryAddresstown;
					deliveryCounty = data.deliveryAddresscounty;
					deliveryEirCode = data.deliveryAddressEirCode;

				}
				customerDetailInput = {
					isAnonymous: false,
					owner: {
						email: data.emailAddress,
						mobileNumber: data.mobileNumber,
						person: {
							birthDate: birthDate,
							firstName: data.firstName,
							lastName: data.lastName,
						}
					},
					deliveryAddress: {
						addressLine1: deliveryaddressLine1,
						addressLine2: deliveryaddressLine2,
						addressLine3: deliveryaddressLine3,
						county: deliveryCounty,
						eircode: deliveryEirCode.replace(/ /g, ''),
						town: deliveryTown
					},
					billingAddress: {
						addressLine1: data.billingAddressaddressLine1,
						addressLine2: data.billingAddressaddressLine2,
						addressLine3: data.billingAddressaddressLine3,
						county: data.billingAddresscounty,
						eircode: data.billingAddressEirCode.replace(/ /g, ''),
						town: data.billingAddresstown
					},
					contactPermission: {
						allowThirdParty: permissionGroupList[2].enabled,
						permissionGroupResponse: [
							{
								name: 'An active customer',
								permissionGroup: 'ACTIVE_CUSTOMER',
								permissions: [
									{
										enabled: permissionGroupList[0].preferenceList[0].enabled,
										name: 'Email',
										permission: 'ALLOW_EMAIL_CONTACT'
									},
									{
										enabled: permissionGroupList[0].preferenceList[1].enabled,
										name: 'SMS',
										permission: 'ALLOW_SMS_CONTACT'
									},
									{
										enabled: permissionGroupList[0].preferenceList[2].enabled,
										name: 'Phone',
										permission: 'ALLOW_PHONE_CONTACT'
									},
									{
										enabled: permissionGroupList[0].preferenceList[3].enabled,
										name: 'FOTS',
										permission: 'ALLOW_FOTS_CONTACT'
									},
									{
										enabled: permissionGroupList[0].preferenceList[4].enabled,
										name: 'Direct mail',
										permission: 'ALLOW_DIRECT_MAIL_CONTACT'
									}
								]
							},
							{
								name: 'No longer a customer',
								permissionGroup: 'NO_LONGER_CUSTOMER',
								permissions: [
									{
										enabled: permissionGroupList[1].preferenceList[0].enabled,
										name: 'Email',
										permission: 'ALLOW_EMAIL_CONTACT'
									},
									{
										enabled: permissionGroupList[1].preferenceList[1].enabled,
										name: 'SMS',
										permission: 'ALLOW_SMS_CONTACT'
									},
									{
										enabled: permissionGroupList[1].preferenceList[2].enabled,
										name: 'Phone',
										permission: 'ALLOW_PHONE_CONTACT'
									},
									{
										enabled: permissionGroupList[1].preferenceList[3].enabled,
										name: 'FOTS',
										permission: 'ALLOW_FOTS_CONTACT'
									},
									{
										enabled: permissionGroupList[1].preferenceList[4].enabled,
										name: 'Direct mail',
										permission: 'ALLOW_DIRECT_MAIL_CONTACT'
									}
								]
							}
						]
					},
					securityQuestion: {
						questionCode: data.securityQuestion.toString(),
						response: data.securityAnswer
					}
				}
			}
			else {

				customerDetailInput = {
					isAnonymous: true,
					owner: {
						email: data.emailAddress,
						mobileNumber: data.mobileNumber,
						person: {
							firstName: data.firstName,
							lastName: data.lastName,
						}
					},
					deliveryAddress: {
						addressLine1: data.deliveryAddressaddressLine1,
						addressLine2: data.deliveryAddressaddressLine2,
						addressLine3: data.deliveryAddressaddressLine3,
						county: data.deliveryAddresscounty,
						eircode: data.deliveryAddressEirCode.replace(/ /g, ''),
						town: data.deliveryAddresstown
					},
					contactPermission: {
						allowThirdParty: false,
						permissionGroupResponse: [
							{
								name: 'An active customer',
								permissionGroup: 'ACTIVE_CUSTOMER',
								permissions: [
									{
										enabled: false,
										name: 'Email',
										permission: 'ALLOW_EMAIL_CONTACT'
									},
									{
										enabled: false,
										name: 'SMS',
										permission: 'ALLOW_SMS_CONTACT'
									},
									{
										enabled: false,
										name: 'Phone',
										permission: 'ALLOW_PHONE_CONTACT'
									},
									{
										enabled: false,
										name: 'FOTS',
										permission: 'ALLOW_FOTS_CONTACT'
									},
									{
										enabled: false,
										name: 'Direct mail',
										permission: 'ALLOW_DIRECT_MAIL_CONTACT'
									}
								]
							},
							{
								name: 'No longer a customer',
								permissionGroup: 'NO_LONGER_CUSTOMER',
								permissions: [
									{
										enabled: false,
										name: 'Email',
										permission: 'ALLOW_EMAIL_CONTACT'
									},
									{
										enabled: false,
										name: 'SMS',
										permission: 'ALLOW_SMS_CONTACT'
									},
									{
										enabled: false,
										name: 'Phone',
										permission: 'ALLOW_PHONE_CONTACT'
									},
									{
										enabled: false,
										name: 'FOTS',
										permission: 'ALLOW_FOTS_CONTACT'
									},
									{
										enabled: false,
										name: 'Direct mail',
										permission: 'ALLOW_DIRECT_MAIL_CONTACT'
									}
								]
							}
						]
					},
				}

			}

			let agreedTermsAndConditions = data.termsAndConditions;
			if (Array.isArray(data.termsAndConditions)) {
				agreedTermsAndConditions = true;
			}

			// update customer details
			const customerData = await graphql.mutate({
				mutation: ENDPOINT.UPDATE_CUSTOMERDETAILS,
				variables: {
					prospectUuid: prospectUuid,
					hasAgreedTermsAndConditions: agreedTermsAndConditions,
					customerDetailInput: customerDetailInput
				},
			});

			setCustomerInformation(customerData.data.updateCustomerDetail);

			// update directory prefernces 
			const updatedCart = await graphql.mutate({
				mutation: ENDPOINT.UPDATE_NDD,
				variables: {
					prospectUuid: prospectUuid,
					cartOfferId: parseInt(cartOfferId),
					nddPreference: nddPreference
				},
			});
			setCartDetails(updatedCart.data.nddPreference);
			history.push(nextStepUrl);
		}
		catch (err) {
			setCustomerUpdateError(err.message);
			window.scrollTo(0, 0);
		} finally {
			setContinueDisabled(false);
		}
	}
	const onSubmit = data => {
		console.log(' on submit ......' + data.termsAndConditions);
		let isError = false;
		if (Object.keys(methods.errors).length > 0) {
			isError = true;
			Object.keys(methods.errors).forEach((item) => {
				methods.setError(item, methods.errors[item].type, methods.errors[item].message);
			});
		}
		if (Array.isArray(data.termsAndConditions) && data.termsAndConditions.length == 0) {
			isError = true;
			methods.setError('termsAndConditions', 'manual', validation.termsNconditionsRequired);
			var termsAndConditionsElement = document.querySelector('#termsAndConditions');
			termsAndConditionsElement.scrollIntoView();
		}
		else if (!data.termsAndConditions) {
			isError = true;
			methods.setError('termsAndConditions', 'manual', validation.termsNconditionsRequired);
			termsAndConditionsElement = document.querySelector('#termsAndConditions');
			termsAndConditionsElement.scrollIntoView();
		}
		if (isEirCodeConfirmed() && !isError) {
			updateCustomerDetails(data);
		}

	}; // your form submit function which will invoke after successful validation

	if (localStorage.getItem('prospectUuid')) {
		return (

			<FormContext {...methods}>
				<EirCheckoutHeader customerType={customerType} setCustomerType={setCustomerType} />
				<form>
					<div className={classes.layout}>
						{customerUpdateError && <span className={classes.errorMessage}>{customerUpdateError}</span>}
						{customerType === 'guest' && (
							<Paper elevation={3} className={classes.paper}>
								<EirCustomerDetails isGuest />
								<EirAddressDetails isGuest />
								<EirTermsNConditions />
							</Paper>
						)}
						{customerType === 'registered' && (
							<EirRegisteredCustomer
								customerInformation={customerInformation}
								setDirectoryPreference={setDirectoryPreference}
								directoryPreference={directoryPreference}
							/>
						)}
					</div>
					<EirOrderSummary buttonLabel='Go to Payment' price={totalPrice} handleNext={methods.handleSubmit(onSubmit)} continueDisabled={continueDisabled} />
				</form>
			</FormContext>

		);
	}
	else {
		return (<EirEmptyCart url={PREPAY_PLAN_URL} />);
	}

} 
